import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M3.51 10h-1.5V3.26l.75-.75H9.5v1.5H3.51z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.245 14.49h-7.5l-.75-.75V6.245l.75-.75h7.5l.75.75v7.495zm-6.75-1.5h6V6.995h-6z"
    }, null, -1)
  ])))
}
export default { render: render }